/* global require */
import Vue from "vue";
import { trans } from "common/translate";

export default Vue.component("manuscript-metadata", {
  props: [ "manuscriptModel" ],

  data() {
    return {
      trans: trans,
      // Contains the metadata fields to be checked and displayed to the user
      // in the sidebar
      metadataFields: [
        [ "Site", "site" ],
        [ "Manuscript Type", "manuscript_type" ],
        [ "Composition Type", "composition_type" ],
        [ "Language", "script_language" ],
        [ "Script", "script_type" ],
        [ "Period", "period" ],
        [ "Material", "material" ]
      ],
      urlForField: metadata => {
        return `/explore-the-archive/search#q=${metadata[1]}:'${this.manuscriptModel[metadata[1]]}'`;
      },
    };
  },

  template: require("./templates/manuscript-metadata.html"),
});





// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/manuscript-metadata.js